/**
 * Enum for Scope Operation Types
 * Used to specify the type of operation when managing eQMS scopes
 */
export enum ScopeOperationType {
  CreateScope = 1,
  UpdateScope = 2
}
